<template>
    <div class="chat-container" v-if="project">
        <ChatBody class="messages" :project="project" />
        <ChatProjectFilesAndInfo class="description" :projectId="id" />
    </div>
</template>

<script>
import ChatBody from '../components/chat/Body.vue'
import ChatProjectFilesAndInfo from '@/components/chat/Info.vue';
export default {
    name:'ChatPage',
    props: {
        id: { required: true },
    },

    components: {
        ChatBody,
        ChatProjectFilesAndInfo,
    },

    computed: {
        project() {
            return this.$store.getters['projects/id'](this.id)
        }
    },

    mounted() {
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.chat-container {
    // width: 100%;
    height: 100%;
    overflow: hidden;
    display: grid;
    padding: 2rem;
    grid-template-rows: auto minmax(60vh, 1fr);
    grid-template-areas:
        'info_projects'
        'body';
    gap: 1rem;

    .messages {
        grid-area: body;
        background: var(--navbar-bg-color);

    }

    .description {
        grid-area: info_projects;
        background: var(--navbar-bg-color);
        border-radius: 10px;
        min-height: 0;
        height: 100%;
        overflow: auto;
    }
}
</style>
